import React from "react";

const Configure = () => {
  return (
    <div className="d-flex justify-content-center align-items-center fs-1 fw-bold">
      Configure
    </div>
  );
};

export default Configure;
